import React from 'react';

interface CategoryItem {
  name: string;
  count: number;
  percentage: number;
}

interface CategoryBreakdownCardProps {
  categories: CategoryItem[];
}

export const CategoryBreakdownCard: React.FC<CategoryBreakdownCardProps> = ({ categories }) => {
  return (
    <div className="bg-white p-5 rounded-2xl border border-slate-200/90 shadow-2xs space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-bold text-slate-900">Sebaran Kategori Judul</h3>
        <span className="text-xs text-slate-400">{categories.length} Kategori</span>
      </div>

      <div className="space-y-2 pt-1">
        {categories.slice(0, 6).map((cat) => (
          <div key={cat.name} className="flex items-center justify-between p-2 rounded-xl bg-slate-50 text-xs">
            <span className="font-medium text-slate-700">{cat.name}</span>
            <div className="flex items-center gap-2 font-mono">
              <span className="font-bold text-slate-900">{cat.count} buku</span>
              <span className="text-[11px] text-slate-400">({cat.percentage}%)</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
